import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectPromoSearchTypes as selectAllPromoSearchTypeValues } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';

// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { NonEmptyArray } from 'packages/JsonQuery';
import { useCallback } from 'react';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';
import { getSubsidizedMortgageModifierValue, removeSubsidizedMortgageFromValues } from '../utils';

export const usePromoTypeChange = () => {
  const allPromoSearchTypeValues = useSelector(selectAllPromoSearchTypeValues);
  const promoSearchTypes = useSelector(selectPromoSearchTypes);

  const onChange = useFilterChangeCallback();

  return useCallback(
    (newValue: NonEmptyArray<string> | string | null | undefined) => {
      let _value: NonEmptyArray<string> | null = null;

      /* istanbul ignore next */
      if (Array.isArray(newValue)) {
        _value = newValue;
      } else if (!newValue) {
        _value = null;
      } else {
        _value = [newValue];
      }

      onChange(
        {
          action: 'setIsSubsidisedMortgage',
          arguments: [getSubsidizedMortgageModifierValue(_value)],
        },
        {
          action: 'setPromoSearchTypes',
          arguments: [
            {
              allValues: allPromoSearchTypeValues,
              newValues: removeSubsidizedMortgageFromValues(_value),
              availableFilterValues: getPromoSearchFilterValuesByType('mortgage', promoSearchTypes),
            },
          ],
        },
      );
    },
    [allPromoSearchTypeValues, onChange, promoSearchTypes],
  );
};
